export default __webpack_public_path__ + "static/media/02.ffecb9cf.png";